import { Component, OnInit } from '@angular/core';

import { UrlInfo } from '../../models/url.info.model';
import { UrlService } from '../../services/url.service';

@Component({
  selector: 'app-saikitubereference',
  templateUrl: './saiki-tube-reference.component.html',
  styleUrls: ['./saiki-tube-reference.component.css']
})
export class SaikiTubeReferenceComponent implements OnInit {

  urlInfo: UrlInfo;

  constructor(private urlService: UrlService) { }

  ngOnInit() {
    this.urlService.getSaikiTubeUrl().subscribe(response => this.urlInfo = response);
  }
}
